import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { LOGOUT } from '../store/actions.type'

import jwtService from '../services/jwtService'

let baseURL = (process.env.ROOT_API || process.env.DEFAULT_API).trim()

function getInitializedApi (config) {
  let axiosConfig = {
    baseURL: baseURL,
    responseType: 'json',
    headers: {},
    ...config
  }

  let token = jwtService.getToken()
  if (token && token !== '') {
    axiosConfig.headers.Authorization = 'Bearer ' + token
  }

  let tenantId = store.getters.tenantId
  if (tenantId && tenantId !== '') {
    axiosConfig.headers['X-TenantId'] = tenantId
  }

  let api = axios.create(axiosConfig)

  api.interceptors.response.use(undefined, (err) => {
    return new Promise((resolve, reject) => {
      if (err.response.status === 401 && !!err.response.config && !err.response.config.__isRetryRequest) {
        if (store.getters.isLoggedIn) {
          store.dispatch(LOGOUT)
          router.push('/')
        }
      }
      throw err
    })
  })

  return api
}

class Api {
  get (url, params) {
    return getInitializedApi().get(url, params)
  }

  getAllPages (url, params = {}) {
    return new Promise((resolve) => {
      const api = getInitializedApi()
      params.pageSize = 0
      api.get(url, { params: params }).then((emptyResponse) => {
        const afterGet = { pageSize: emptyResponse.data.totalItems }
        api.get(url, { params: afterGet }).then((response) => {
          resolve(response)
        })
      })
    })
  }

  post (url, params) {
    return getInitializedApi().post(url, params)
  }

  put (url, params) {
    return getInitializedApi().put(url, params)
  }

  delete (url, params) {
    return getInitializedApi().delete(url, params)
  }
}

export default new Api()



// WEBPACK FOOTER //
// ./src/api/index.js